import HTTP from '@rocketfid/api'

const state = {
  items: [],
  filterStatus: 'all',
}

// getters
const getters = {
  waves: (state) => {
    return state.items
  },
  getWaveById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  },
  getByStatus: (state) => (status) => {
    if (status.length === 0 || status == 'all') {
        return state.items
    }
    return state.items.filter(wave => status == wave.status)
  },
  getFilterStatus: (state) => {
    return state.filterStatus
  }
}

// actions
const actions = {
  loadWaves ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .wave.getAll()
      .then((waves) => {
        dispatch('waves/resetWaves', null, { root: true })
        commit('ADD_WAVE_ITEMS', { items: waves })
        return waves
      })
  },

  loadWave ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .wave.get(id)
      .then((wave) => {
        commit('UPDATE_WAVE_ITEM', { item: wave })
        return wave
      })
  },

  resetWaves ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('RESET_WAVE_ITEMS')
      resolve()
    })
  },

  addWave ({ commit, rootGetters }, { wave }) {
    let sitekey = rootGetters['account/currentSitekey']

    delete wave.reward

    return HTTP
      .setInstance(sitekey)
      .wave.create(wave)
      .then((wave) => {
        commit('ADD_WAVE_ITEM', { item: wave })
        return wave
      })
  },

  /* A function that is called when the user uploads a csv file. */
  async addCsvFile ({ commit, rootGetters }, { wave, csvFile}) {
    let sitekey = rootGetters['account/currentSitekey']
    var formData = new FormData();

    formData.append("csv", csvFile);

    return HTTP
      .setInstance(sitekey)
      .axios.post(process.env.API + '/wave/' + wave.id + '/csv/', formData)
      .then((rep) => {
        commit('UPDATE_WAVE_ITEM', { item: rep.data })
        return rep.data
      })
  },

  async updateCsvFile ({ commit, rootGetters }, { wave, csvFile}) {
    let sitekey = rootGetters['account/currentSitekey']
    var formData = new FormData();

    formData.append("csv", csvFile);

    return HTTP
      .setInstance(sitekey)
      .axios.post(process.env.API + '/wave/' + wave.id + '/updatecsv/', formData)
      .then((rep) => {
        return rep.data
      })
  },

  addStepWave ({ commit, rootGetters }, { idWave, step }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .wave.createStep(idWave, step)
      .then((wave) => {
        commit('UPDATE_WAVE_ITEM', { item: wave })
        return wave
      })
  },

  updateWave ({ commit, rootGetters }, { wave }) {
    let sitekey = rootGetters['account/currentSitekey']

    delete wave.reward

    return HTTP
      .setInstance(sitekey)
      .wave.update(wave)
      .then((wave) => {
        commit('UPDATE_WAVE_ITEM', { item: wave })
        return wave
      })
  },

  removeWave ({ commit, rootGetters }, { wave }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .wave.delete(wave)
      .then((wave) => {
        commit('REMOVE_WAVE_ITEM', { item: wave })
      })
  },

  getStepStats ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .axios.get(process.env.API + '/wave/' + id + '/reporting/steps/')
      .then((results) => {
        return {
          id: id,
          results: results.data
        }
      })
  },

  getStepStatsPerDay ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .axios.get(process.env.API + '/wave/' + id + '/reporting/steps/perday/')
      .then((results) => {
        return results.data
      })
  },
  setFilterStatus ({ commit, rootGetters }, { filterStatus }) {
    commit('UPDATE_FILTER_STATUS', { status: filterStatus })
  }
}

// mutations
const mutations = {
  ADD_WAVE_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_WAVE_ITEMS: (state) => {
    state.items = []
  },

  ADD_WAVE_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_WAVE_ITEM: (state, { item }) => {
    let find = false

    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
        find = true
      }
    }

    if (!find) {
      state.items.push(item)
    }
  },
  REMOVE_WAVE_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  },

  UPDATE_FILTER_STATUS: (state, { status }) => {
    state.filterStatus = status;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/waves.js